;(function ($) {
  $(document).ready(function () {
    function siteInit() {}

    siteInit()

    function animeInit() {
      $("#welcome").waypoint(
        function () {
          var tl = anime.timeline({
            easing: "linear",
            duration: 500,
          })

          tl.add({
            targets: "#welcome .welcome__text h1",
            opacity: 1,
          })

          tl.add({
            targets: "#welcome .welcome__text .text",
            opacity: 1,
            translateY: [40, 0],
          })

          this.destroy()
        },
        {
          offset: "70%",
        },
      )

      $("#key-findings").waypoint(
        function () {
          var tl = anime.timeline({
            easing: "linear",
            duration: 500,
          })

          $("#key-findings .item").each(function () {
            tl.add({
              targets: $(this)[0],
              opacity: 1,
              translateY: [30, 0],
            })
          })

          tl.add({
            targets: "#key-findings .quote",
            opacity: 1,
          })

          this.destroy()
        },
        {
          offset: "70%",
        },
      )

      $(".container > h2, .heading, .image").each(function () {
        var $this = $(this)

        $this.waypoint(
          function () {
            anime({
              targets: $this[0],
              opacity: 1,
              easing: "linear",
              duration: 300,
            })

            this.destroy()
          },
          {
            offset: "75%",
          },
        )
      })
    }

    animeInit()
  })
})(jQuery)
